import { render } from "./SumTableFooter.vue?vue&type=template&id=6fed224b"
import script from "./SumTableFooter.vue?vue&type=script&lang=js"
export * from "./SumTableFooter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__